import { render, staticRenderFns } from "./Vol01.vue?vue&type=template&id=b5380ec6&scoped=true&"
import script from "./Vol01.vue?vue&type=script&lang=js&"
export * from "./Vol01.vue?vue&type=script&lang=js&"
import style0 from "./Vol01.vue?vue&type=style&index=0&id=b5380ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5380ec6",
  null
  
)

export default component.exports